export const facebook = [
  '0 0 32 32',
  `<path fill="none" stroke="#9298a8" stroke-width="1.4545" stroke-miterlimit="4" stroke-linecap="round" stroke-linejoin="round" d="M24.218 1.057h-4.483c-1.982 0-3.882 0.787-5.283 2.188s-2.188 3.302-2.188 5.283v4.483h-4.483v5.977h4.483v11.954h5.977v-11.954h4.483l1.494-5.977h-5.977v-4.483c0-0.396 0.157-0.776 0.438-1.057s0.66-0.438 1.057-0.438h4.483v-5.977z"></path>`,
]
